module.exports = __webpack_public_path__ + "img/th-box.cd46ae35.png";